import React from "react";

import {
    LineChart,
    Line,
    ResponsiveContainer
  } from "recharts";

const lineChart = (donorData) => {

    const CustomizedDot = (props) => {
      const { cx, cy, payload } = props;

      if (payload.visibleDot) {
        return (
          <svg x={cx - 4} y={cy - 4} width={8} height={8} fill="white">
            <g transform="translate(4 4)">
              <circle r="4" fill="#909191" />

            </g>
          </svg>
        );
      }

      return null;
    };
    
    return (
      <ResponsiveContainer width="100%" height={150}>
        <LineChart
          width={300}
          height={150}
          data={donorData}
          margin={{
            top: 16,
            right: 30,
            left: 20,
            bottom: 20
          }}
        >
          
          <Line dataKey="donors" stroke="#909191" strokeWidth={2} dot={<CustomizedDot />} />
        </LineChart>
      </ResponsiveContainer>
    );
  }

  export default lineChart;